{
  "language": {
    "title": "Izaberite jezik",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "Zdravo, kako možemo da vam pomognemo?",
    "checkIn": "Prijavljivanje",
    "independentManualCheckIn": "Bez termina",
    "integratedManualCheckIn": "Ručno prijavljivanje",
    "checkOut": "Odjavljivanje",
    "manualCheckOut": "Ručno odjavljivanje",
    "parcelDelivery": "Dostava paketa",
    "foodDelivery": "Dostava hrane",
    "callReception": "Pozovite recepciju",
    "overview": "Pregled",
    "unavailable": "Recepcija trenutno nije dostupna."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Izaberite opciju za prijavljivanje",
        "manual": "Ručno prijavljivanje",
        "code": "Prijavite se PIN-om ili QR kodom",
        "code-no-qr": "Prijavite se PIN kodom"
      },
      "checkout": {
        "title": "Izaberite opciju za odjavljivanje",
        "manual": "Odjavite se imenom",
        "code": "Odjavite se PIN-om ili QR kodom",
        "code-no-qr": "Odjavite se PIN kodom"
      }
    },
    "title": "Sada možete da skenirate QR kod ili unesete PIN kod.",
    "orText": "Ili",
    "qrScanner": {
      "checkin": {
        "title": "Izaberite opciju za prijavljivanje"
      },
      "checkout": {
        "title": "Izaberite opciju za odjavljivanje"
      },
      "btn": "Skenirajte QR kod"
    },
    "hidScanner": {
      "title": "Prinesite QR kod skeneru ispod ili unesite PIN kod"
    },
    "pinOnly": {
      "title": "Unesite PIN kod"
    },
    "pinCode": "Unesite PIN kod",
    "manually": {
      "checkin": "Nemate kod za prijavljivanje?"
    },
    "status": {
      "idle": {
        "title": "Skenira se kod.",
        "message": "Molimo sačekajte...",
        "nfc": {
          "title": "Vaš tag se skenira.",
          "message": "Molimo sačekajte..."
        }
      },
      "loading": {
        "title": "Skenira se kod.",
        "message": "Molimo sačekajte...",
        "nfc": {
          "title": "Vaš tag se skenira.",
          "message": "Molimo sačekajte..."
        }
      },
      "error": {
        "title": "Kod je neispravan.",
        "message": "Molimo pokušajte ponovo!",
        "nfc": {
          "title": "Tag nije validan.",
          "message": "Molimo pokušajte ponovo!"
        },
        "meeting": {
          "tooEarly": {
            "title": "Stigli ste malo ranije",
            "message": "Vaš kod važi od {{validFromTime}}. Sastanak počinje u {{meetingStartTime}}."
          },
          "tooLate": {
            "title": "Ovaj kod je istekao",
            "message": "Sastanak se završio u {{meetingEndTime}}. Vaš kod je važio do {{validUntilTime}}."
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Uspešno ste se prijavili.",
            "message": "Hvala vam."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Uspešno ste se prijavili.",
              "message": "Hvala vam."
            },
            "email-sms": {
              "title": "Uspešno ste se prijavili.",
              "message": "Vaša kontakt osoba je obaveštena."
            },
            "call-ping": {
              "title": "Uspešno ste se prijavili.",
              "message": "Sada ćemo uspostaviti telefonski poziv sa vašom kontakt osobom."
            },
            "teams-call": {
              "title": "Uspešno ste se prijavili.",
              "message": "Sada ćemo uspostaviti Microsoft Teams poziv sa vašom kontakt osobom."
            },
            "badge": {
              "title": "Hvala vam što ste se prijavili, vaša bedž će biti odštampan.",
              "message": ""
            },
            "video-call": {
              "title": "Uspešno ste se prijavili.",
              "message": "Uspostavljanje video poziva sa kontakt osobom."
            }
          },
          "Employee": {
            "title": "Uspešno ste se prijavili.",
            "message": "Hvala vam.",
            "badge": {
              "title": "Hvala vam što ste se prijavili, vaša bedž će biti odštampan.",
              "message": ""
            }
          },
          "Visitor": {
            "title": "Uspešno ste se prijavili.",
            "message": "Hvala vam.",
            "badge": {
              "title": "Hvala vam što ste se prijavili, vaša bedž će biti odštampan.",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "Uspešno ste se odjavili.<br/>",
            "message": "Vidimo se uskoro."
          },
          "MeetingAttendee": {
            "title": "Uspešno ste se odjavili.",
            "message": "Vidimo se uskoro."
          },
          "Employee": {
            "title": "Uspešno ste se odjavili.",
            "message": "Vidimo se uskoro."
          },
          "Visitor": {
            "title": "Uspešno ste se odjavili.",
            "message": "Vidimo se uskoro."
          },
          "access": {
            "title": "Uspešno ste se odjavili.",
            "message": "Sada možete da otvorite vrata."
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "Još par podataka pre prijave",
    "subtitle": "Polja označena sa * su obavezna",
    "btn": "Prijavite se",
    "placeholder": {
      "other": "Drugo...",
      "otherInput": "Unesite svoju opciju"
    },
    "error": {
      "required": "Niste popunili ovo polje",
      "email": "Neispravna e-mail adresa",
      "phone": "Neispravan broj telefona"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "Molimo popunite.",
      "documentScanner": "Obratite pažnju prilikom ubacivanja dokumenta:"
    },
    "subtitle": {
      "default": "Napomena - svako polje * je obavezno",
      "documentScanner": [
        {
          "parts": [
            { "text": "Strana sa ", "bold": false },
            { "text": "znakovima <<< >>> (MRZ) ", "bold": true },
            { "text": "mora biti ", "bold": false },
            { "text": "okrenuta prema kiosku / skeneru.", "bold": true }
          ]
        },
        {
          "parts": [
            { "text": "Držite karticu mirno ", "bold": false },
            { "text": "dok se polja ne popune automatski.", "bold": true }
          ]
        }
      ]
    },
    "noOption": "Nema opcije",
    "btn": "Prijavite se",
    "placeholder": {
      "name": "Vaše ime *",
      "email": "Vaš e-mail *",
      "phone": "Broj mobilnog",
      "contactName": "Vaša kontakt osoba*",
      "other": "Ostalo..."
    },
    "error": {
      "required": "Niste popunili ovo polje",
      "name": "Neispravno ime",
      "email": "Neispravna e-mail adresa",
      "phone": "Neispravan broj mobilnog"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "Molimo sačekajte...",
          "message": "Vaša registracija se obrađuje."
        },
        "contact": {
          "title": "Molimo sačekajte...",
          "message": "Vaš kontakt se obaveštava."
        }
      },
      "loading": {
        "no-contact": {
          "title": "Molimo sačekajte...",
          "message": "Vaša registracija se obrađuje."
        },
        "contact": {
          "title": "Molimo sačekajte...",
          "message": "Vaš kontakt se obaveštava."
        }
      },
      "success": {
        "no-email-sms": {
          "title": "Uspešno ste se prijavili.",
          "message": "Hvala vam."
        },
        "email-sms": {
          "title": "Uspešno ste se prijavili.",
          "message": "Vaša kontakt osoba je obaveštena."
        },
        "call-ping": {
          "title": "Uspešno ste se prijavili.",
          "message": "Sada ćemo uspostaviti telefonski poziv sa vašom kontakt osobom."
        },
        "teams-call": {
          "title": "Uspešno ste se prijavili.",
          "message": "Sada ćemo uspostaviti Microsoft Teams poziv sa vašom kontakt osobom."
        },
        "badge": {
          "title": "Hvala vam što ste se prijavili, vaša bedž će biti odštampan.",
          "message": ""
        },
        "video-call": {
          "title": "Uspešno ste se prijavili.",
          "message": "Uspostavljanje video poziva sa kontakt osobom."
        }
      },
      "error": {
        "title": "Nešto je pošlo po zlu.",
        "message": "Molimo pokušajte ponovo!"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "Dokument nije važeći",
        "message": "Dokument nije moguće verifikovati ili je istekao. Molimo unesite svoje podatke ručno."
      }
    }
  },
  "manualCheckout": {
    "title": "Unesite svoje ime da se odjavite",
    "btn": "Odjavite se",
    "form": {
      "placeholder": {
        "name": "Vaše puno ime *"
      },
      "loading": "Učitava...",
      "noOptions": "Nema opcija"
    },
    "error": {
      "required": "Niste popunili ovo polje",
      "name": "Neispravno ime"
    },
    "status": {
      "idle": {
        "title": "Obrađujemo vaše informacije.",
        "message": "Molimo sačekajte..."
      },
      "loading": {
        "title": "Obrađujemo vaše informacije.",
        "message": "Molimo sačekajte..."
      },
      "success": {
        "title": "Uspešno ste se odjavili.",
        "message": "Hvala vam i prijatan dan."
      },
      "successAccess": {
        "title": "Uspešno ste se odjavili.",
        "message": "Sada možete da otvorite vrata."
      },
      "error": {
        "title": "Došlo je do greške tokom odjavljivanja.",
        "message": "Molimo pokušajte ponovo!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Želite li da obavestite svoju kontakt osobu?",
      "email-sms": "Poslali smo e-mail/SMS vašoj kontakt osobi.<br/>Da li želite dodatno da uspostavite poziv sa njima?"
    },
    "callBtn": "Pozovite",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Video poziv",
    "teamsCallBtn": "Teams poziv",
    "teamsMessageBtn": "Teams poruka",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "Otkaži",
    "cancelBtn": "Otkaži poziv",
    "status": {
      "connecting": {
        "title": "Uspostavlja se poziv.<br/>Molimo sačekajte...",
        "message": ""
      },
      "ringing": {
        "title": "Pozivamo vašu kontakt osobu<br/>Molimo sačekajte...",
        "message": ""
      },
      "ringingReception": {
        "title": "Poziv je započet...",
        "message": ""
      },
      "open": {
        "title": "Poziv je u toku.",
        "message": ""
      },
      "close": {
        "title": "Poziv je završen.<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "Poziv je završen.<br/>Sada možete da otvorite vrata.",
        "message": ""
      },
      "closeReception": {
        "title": "Poziv je završen.",
        "message": ""
      },
      "error": {
        "title": "Poziv nije uspostavljen.<br/>Pozovite ponovo?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Obaveštavamo vašu kontakt osobu.",
        "message": "Molimo sačekajte..."
      },
      "loading": {
        "title": "Obaveštavamo vašu kontakt osobu.",
        "message": "Molimo sačekajte..."
      },
      "success": {
        "title": "SMS je poslat. Kontakt je obavešten.",
        "message": "Hvala vam!"
      },
      "successAccess": {
        "title": "SMS je poslat. Kontakt je obavešten.",
        "message": "Sada možete da otvorite vrata."
      },
      "error": {
        "title": "SMS nije poslat.",
        "message": "Molimo pokušajte ponovo!"
      }
    }
  },
  "videoCall": {
    "title": "Video poziv",
    "endCall": "Završi poziv",
    "status": {
      "idle": {
        "title": "Kreiramo video sobu.",
        "message": "Molimo sačekajte..."
      },
      "loading": {
        "title": "Kreiramo video sobu.",
        "message": "Molimo sačekajte..."
      },
      "success": {
        "title": "Video soba je uspešno kreirana.",
        "message": "Ulazimo u sobu..."
      },
      "error": {
        "title": "Video soba nije uspešno kreirana.",
        "message": "Molimo pokušajte ponovo!"
      }
    }
  },
  "teamsCall": {
    "title": "Teams poziv",
    "controls": {
      "startCall": "Započni poziv",
      "endCall": "Izađi",
      "camera": "Kamera",
      "cameraOff": "Isključi kameru",
      "mic": "Mikrofon",
      "micOff": "Isključi mikrofon",
      "ringing": "Poziva...",
      "noAnswer": "Niko se nije javio."
    },
    "status": {
      "connecting": {
        "title": "Uspostavlja se poziv.<br/>Molimo sačekajte...",
        "message": ""
      },
      "ringing": {
        "title": "Pozivamo vašu kontakt osobu<br/>Molimo sačekajte...",
        "message": ""
      },
      "connected": {
        "title": "Uspostavlja se poziv",
        "message": ""
      },
      "disconnected": {
        "title": "Poziv je završen.<br/>",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "Poziv je završen.<br/>Sada možete da otvorite vrata.",
        "message": ""
      },
      "error": {
        "title": "Poziv nije uspostavljen.<br/>Molimo pokušajte ponovo",
        "message": ""
      },
      "noAnswer": {
        "title": "Niko se nije javio.<br/>Molimo pokušajte ponovo.",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "Obaveštavamo vašu kontakt osobu.",
        "message": "Molimo sačekajte..."
      },
      "loading": {
        "title": "Obaveštavamo vašu kontakt osobu.",
        "message": "Molimo sačekajte..."
      },
      "success": {
        "title": "Poruka je poslata. Kontakt je obavešten.",
        "message": "Hvala vam!"
      },
      "successAccess": {
        "title": "Poruka je poslata. Kontakt je obavešten.",
        "message": "Sada možete da otvorite vrata."
      },
      "error": {
        "title": "Poruka nije poslata.",
        "message": "Molimo pokušajte ponovo!"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "Obaveštavamo vašu kontakt osobu.",
        "message": "Molimo sačekajte..."
      },
      "loading": {
        "title": "Obaveštavamo vašu kontakt osobu.",
        "message": "Molimo sačekajte..."
      },
      "success": {
        "title": "Poruka je poslata. Kontakt je obavešten.",
        "message": "Hvala vam!"
      },
      "successAccess": {
        "title": "Poruka je poslata. Kontakt je obavešten.",
        "message": "Sada možete da otvorite vrata."
      },
      "error": {
        "title": "Poruka nije poslata.",
        "message": "Molimo pokušajte ponovo!"
      }
    }
  },
  "packageDelivery": {
    "title": "Kako je lepo što dostavljate paket!",
    "subtitle": "Izaberite i obavestite primaoca",
    "subtitle1": "Pritisnite dugme ispod da nas obavestite da ste tu!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Za koga je paket"
      },
      "error": {
        "contact": {
          "required": "Niste popunili ovo polje"
        }
      }
    },
    "button": {
      "submit": "Obavesti"
    },
    "status": {
      "loading": {
        "title": "Obaveštavamo kontakt osobu.",
        "message": "Molimo sačekajte..."
      },
      "success": {
        "no-email-sms": {
          "title": "Hvala vam na dostavi!",
          "message": ""
        },
        "email-sms": {
          "title": "Kontakt osoba je obaveštena.",
          "message": "Hvala vam na dostavi!"
        },
        "call-ping": {
          "title": "Hvala vam na dostavi!",
          "message": "Sada će se uspostaviti telefonska veza sa kontakt osobom."
        },
        "teams-call": {
          "title": "Hvala vam na dostavi!",
          "message": "Sada će se uspostaviti Microsoft Teams poziv sa vašom kontakt osobom."
        },
        "video-call": {
          "title": "Hvala vam na dostavi!",
          "message": "Uspostavljanje video poziva sa kontakt osobom."
        }
      },
      "error": {
        "title": "Nešto je pošlo po zlu.",
        "message": "Molimo pokušajte ponovo!"
      }
    }
  },
  "foodDelivery": {
    "title": "Kako je lepo što dostavljate hranu!",
    "subtitle": "Izaberite i obavestite primaoca",
    "subtitle1": "Pritisnite dugme ispod da nas obavestite da ste tu!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Za koga je hrana"
      },
      "error": {
        "contact": {
          "required": "Niste popunili ovo polje"
        }
      }
    },
    "button": {
      "submit": "Obavesti"
    },
    "status": {
      "loading": {
        "title": "Obaveštavamo kontakt.",
        "message": "Molimo sačekajte!"
      },
      "success": {
        "no-email-sms": {
          "title": "Hvala vam na dostavi!",
          "message": ""
        },
        "email-sms": {
          "title": "Kontakt je obavešten.",
          "message": "Hvala vam na dostavi!"
        },
        "call-ping": {
          "title": "Hvala vam na dostavi!",
          "message": "Sada će se uspostaviti telefonska veza sa vašom kontakt osobom."
        },
        "teams-call": {
          "title": "Hvala vam na dostavi!",
          "message": "Sada će se uspostaviti Microsoft Teams poziv sa vašom kontakt osobom."
        },
        "video-call": {
          "title": "Hvala vam na dostavi!",
          "message": "Uspostavljanje video poziva sa kontakt osobom."
        }
      },
      "error": {
        "title": "Nešto je pošlo po zlu.",
        "message": "Molimo pokušajte ponovo!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Molimo skenirajte QR kod",
    "subtitle": "Poravnajte QR kod unutar crvenih uglova i držite telefon mirno.",
    "error": "Neispravan format QR koda",
    "unknownError": "Došlo je do nepoznate greške tokom skeniranja"
  },
  "common": {
    "backBtn": "Nazad"
  },
  "previewPDF": {
    "page": {
      "of": "od",
      "previous": "Prethodna",
      "next": "Sledeća"
    },
    "button": {
      "cancel": "Otkaži",
      "accept": "Prihvati",
      "next": "Sledeće"
    },
    "title": {
      "consent": "Potrebna saglasnost"
    }
  },
  "offline": {
    "title": "Van mreže",
    "receptionMessage": "Digitalna recepcija je trenutno van mreže i ne može se koristiti, potrebno je proveriti internet konekciju!",
    "check": "Da li ste posetilac i želite da razgovarate sa zaposlenim direktno? Molimo pozovite {{receptionistPhone}}"
  },
  "overview": {
    "title": "Unesite kod da otvorite pregled!",
    "noUsers": "Nema registracija",
    "status": {
      "success": {
        "title": "Kod je valjan.",
        "message": ""
      },
      "error": {
        "title": "Kod je neispravan.",
        "message": "Molimo pokušajte ponovo!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Molimo sačekajte...",
        "message": ""
      },
      "success": {
        "title": "Uspešno odjavljivanje.",
        "message": ""
      },
      "error": {
        "title": "Nešto je pošlo po zlu.",
        "message": "Molimo pokušajte ponovo!"
      }
    },
    "listTitle": "Lista osoba koje su se prijavile danas ali se nisu odjavile",
    "page": "Stranica ",
    "table": {
      "head": {
        "fullName": "Ime",
        "type": "Tip",
        "checkedinAt": "Prijavljen u",
        "host": "Domaćin"
      },
      "type": {
        "Package": "Dostava paketa",
        "Food": "Dostava hrane",
        "Visitor": "Posetilac",
        "MeetingAttendee": "Pozvan posetilac",
        "Employee": "Zaposleni",
        "Guest": "Posetilac"
      }
    },
    "confirmModal": {
      "title": "Da li ste sigurni da želite da odjavite {{fullName}}?",
      "cancel": "Otkaži",
      "checkout": "Odjavi"
    }
  },
  "wifi": {
    "title": "Povežite se na Wi-Fi mrežu"
  },
  "door": {
    "external": {
      "title": "Otvaranje vrata",
      "subtitle": "Vrata će se uskoro otvoriti. Molimo sačekajte..."
    },
    "control": {
      "title": "Sada možete da otvorite vrata",
      "subtitle": "Molimo pritisnite dugme ispod!",
      "openBtn": "Otvori vrata"
    },
    "status": {
      "success": {
        "title": "Vrata su otvorena",
        "message": ""
      },
      "error": {
        "title": "Nešto je pošlo po zlu",
        "message": "Molimo kontaktirajte svoju kontakt osobu da otvori vrata."
      },
      "loading": {
        "title": "Vrata se otvaraju...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "Da li želite da napravite fotografiju kao deo procesa prijavljivanja?",
    "required": {
      "title": "Potrebna je verifikacija fotografijom!",
      "instructions": "Molimo stanite pred kameru i pratite instrukcije na ekranu.",
      "securityNotice": "Iz bezbednosnih razloga i radi verifikacije, fotografija je potrebna tokom prijavljivanja.",
      "privacyInfo": "Poštujemo vašu privatnost. Vaši podaci se bezbedno čuvaju i koriste se samo za identifikaciju.",
      "closingMessage": "Hvala vam na saradnji."
    },
    "optional": {
      "title": "Da li želite da napravite fotografiju kao deo procesa prijavljivanja?",
      "instructions": "",
      "securityNotice": "Fotografisanje može pomoći u ubrzanju identifikacije i poboljšanju bezbednosti.",
      "privacyInfo": "Poštujemo vašu privatnost. Ovaj korak je opcionalan, a vaši podaci će biti bezbedno obrađeni.",
      "closingMessage": "Možete preskočiti ovaj korak ako želite."
    },
    "subtitle": "Molimo pozicionirajte se unutar okvira i ne mrdajte za najbolji rezultat",
    "button": {
      "cancel": "Otkaži",
      "accept": "Prihvati",
      "skip": "Preskoči",
      "next": "Sledeće",
      "recapture": "Ponovo fotografiši",
      "continue": "Nastavi"
    },
    "error": "Došlo je do greške tokom fotografisanja. Proces prijavljivanja će se nastaviti bez fotografije."
  },
  "wayfinding": {
    "title": "Gde želite da idete?"
  },
  "callingMenu": {
    "title": "Meni za pozivanje"
  },
  "bell": {
    "status": {
      "success": {
        "title": "Zvono zvoni",
        "message": "Neko će uskoro doći."
      },
      "error": {
        "title": "Nešto nije u redu",
        "message": "Pokušajte ponovo"
      },
      "loading": {
        "title": "Povezivanje...",
        "message": "Molimo sačekajte"
      }
    }
  },
  "access": {
    "control": {
      "title": "Sada možete da otvorite vrata",
      "subtitle": "Molimo pritisnite dugme ispod.",
      "titleAuto": "Automatski pristup vratima",
      "subtitleAuto": "Vrata će se otvoriti automatski za vas",
      "openBtn": "Otvori"
    },
    "status": {
      "success": {
        "title": "Vrata su otvorena",
        "message": ""
      },
      "error": {
        "title": "Nešto je pošlo po zlu",
        "message": "Molimo kontaktirajte svoju kontakt osobu da otvori vrata."
      },
      "loading": {
        "title": "Vrata se otvaraju...",
        "message": ""
      }
    }
  }
}
